import { render, staticRenderFns } from "./emailOrg.vue?vue&type=template&id=bbb82a96&"
import script from "./emailOrg.vue?vue&type=script&lang=js&"
export * from "./emailOrg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports